import { render } from "./FooterGlobale.vue?vue&type=template&id=5a203ab0"
import script from "./FooterGlobale.vue?vue&type=script&lang=js"
export * from "./FooterGlobale.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\vues_js\\v_master_invest\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__